import { createSelector } from 'reselect';

export const getChangeOrders = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.changeOrders.data.changeOrders,
  (changeOrders) => {
    return changeOrders;
  }
);

export const getShowChangeOrderModal = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.changeOrders.ui.showChangeOrderModal,
  (showChangeOrderModal) => {
    return showChangeOrderModal;
  }
);

export const getStartDate = createSelector(
  (state) => state.workOrders.scenes.details.scenes.changeOrders.data.startDate,
  (startDate) => {
    return startDate;
  }
);

export const getCompletionDate = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.changeOrders.data.completionDate,
  (completionDate) => {
    return completionDate;
  }
);

export const getValuesByQuoteId = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.changeOrders.data.valuesByQuoteId,
  (valuesByQuoteId) => {
    return valuesByQuoteId;
  }
);

export const getCurrentView = createSelector(
  (state) => state.workOrders.scenes.details.scenes.changeOrders.ui.currentView,
  (currentView) => {
    return currentView;
  }
);

export const getSelectedChangeOrderId = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.changeOrders.data
      .selectedChangeOrderId,
  (selectedChangeOrderId) => {
    return selectedChangeOrderId;
  }
);

export const getSelectedChangeOrderNumber = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.changeOrders.data
      .selectedChangeOrderNumber,
  (selectedChangeOrderNumber) => {
    return selectedChangeOrderNumber;
  }
);

export const getShowSuccessMessage = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.changeOrders.ui.showSuccessMessage,
  (showSuccessMessage) => {
    return showSuccessMessage;
  }
);

export const getPdf = createSelector(
  (state) => state.workOrders.scenes.details.scenes.changeOrders.ui.pdf,
  (pdf) => {
    return pdf;
  }
);

export const getShowPdfViewer = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.changeOrders.ui.showPdfViewer,
  (showPdfViewer) => {
    return showPdfViewer;
  }
);

export const getShowEmailModal = createSelector(
  (state) =>
    state.workOrders.scenes.details.scenes.changeOrders.ui.showEmailModal,
  (showEmailModal) => {
    return showEmailModal;
  }
);

export const getUsers = createSelector(
  (state) => state.workOrders.scenes.details.scenes.changeOrders.data.users,
  (users) => {
    return users;
  }
);

export const getEmails = createSelector(
  (state) => state.workOrders.scenes.details.scenes.changeOrders.ui.emails,
  (emails) => {
    return emails;
  }
);

export const getSubject = createSelector(
  (state) => state.workOrders.scenes.details.scenes.changeOrders.ui.subject,
  (subject) => {
    return subject;
  }
);

export const getMessage = createSelector(
  (state) => state.workOrders.scenes.details.scenes.changeOrders.ui.message,
  (message) => {
    return message;
  }
);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-orders/store/selectors.js